type Props = {
  icono?: string
  mensaje: string
  titulo?: string
  color?: string
  fs?: number
  dismissible?: boolean
  border?: boolean
  anexo?: string
}

/**
 * Alerta/notificacion configurable con icono, titulo, color, borde,
 * modo dismissible y texto anexo.
 */
export const Alert = ({
  mensaje,
  fs = 5,
  titulo,
  icono = 'fa-solid fa-circle-exclamation fs-2x',
  color = 'dark',
  dismissible = false,
  border = false,
  anexo,
}: Props) => {
  return (
    <>
      <div
        className={`alert ${
          dismissible ? 'alert-dismissible' : ''
        } alert-${color} d-flex align-items-center p-5 border-${border ? 'color' : 'transparent'}`}>
        <span className='me-3'>
          <i className={`text-${color} ${icono}`}></i>
        </span>
        <div className='d-flex flex-column'>
          {titulo && <div className={`mb-1 fw-bold text-${color} fs-${fs - 1}`}>{titulo}</div>}
          <div className={`fs-${fs}`}>{mensaje}</div>
          {anexo && <i className='mt-2 fw-bold'>{anexo}</i>}
        </div>
        {dismissible && (
          <button
            type='button'
            className='position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto'
            data-bs-dismiss='alert'>
            <i className='fa-solid fa-xmark fs-1'></i>
          </button>
        )}
      </div>
    </>
  )
}
